const TmpL005 = (page, section) => {
  const media = [];
  const images = [];
  const materials = [];
  const eMentors = [];

  const image = {
    size: '900px X 900px',
    ...page.content.media,
    page: page.id,
    src: page.label.toLowerCase().replaceAll('-', '_') + '.jpg'
  };
  // add the media object to the media array
  media.push(image);
  images.push(image);

  const modifiedPage = {
    ...page,
    content: {
      core: {
        id: page.content.core.id,
        material: page.id
      },
      media: image,
      eMentor: page.content.eMentor
    }
  };

  const readingAttr = {
    ...page.content.core,
    display_content: 'Reading Attribution Only',
    page: page.id
  };
  // push the reading object to the media array
  media.push(readingAttr);
  // modify the media object to strip out the unnecessary data
  const reading = {
    content: {
      core: page.content.core,
      focus_points: page.content.focus_points,
      pageLabel: page.label
    },
    page: page.id,
    section: section,
    type: 'reading'
  };
  materials.push(reading);

  // update the the ementor content with the page id
  if (page.content.eMentor) {
    page.content.eMentor.forEach((mentor) => {
      const eMentor = {
        ...mentor,
        page: page.id
      };
      eMentors.push(eMentor);
    });
  }

  // Inject page.id into each focus point if present
  if (page.content && Array.isArray(page.content.focus_points)) {
    page.content.focus_points.forEach((fp) => {
      fp.page = page.id;
    });
  }

  // Extract metadata separately
  const metadata = {
    media: media || [],
    images: images || [],
    materials: materials || [],
    eMentor: eMentors,
    focusPoints: page.content.focus_points || []
  };

  return { modifiedPage, metadata };
};

export default TmpL005;
